import focus from "../assets/images/focus.png";
import people from "../assets/images/people.png";
import events from "../assets/images/events.png";

export const alumniData = [
  {
    heading: "Our Focus",
    text: "We exist to sustain the human relationships that began in our home with the potential to transform to so much more through fun, social activities and continuous engagements.",
    image: focus,
  },
  {
    heading: "Our People",
    text: "We are a group of ex-PAC staff in active careers, vocations, or businesses across the globe with a shared goal of making positive impact in connectivity.",
    image: people,
  },
  {
    heading: "Our Events",
    text: "We stay connected all year long through specially curated social and business events that seek to foster our bond, celebrate ourselves, share memorable days and support each other.",
    image: events,
  },
];
